import { faPaintbrush } from "@fortawesome/pro-regular-svg-icons/faPaintbrush";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, TextField, Typography } from '@mui/material';
import { FileThumbnaildGetDto, RequestLifeCycle } from "app/appModels";
import { MprcButton, MprcFormSubHeader, MprcRequestErrorDialog, MprcRequestErrorReport, MprcRequestIndicator, MprcText } from "components";
import { ConvertUploadToFileThumbnaildGetDto, UploadingStatus } from "components/FileUpload/AttachSelection";
import { IconButtonClose } from "components/iconButtons";
import { IconButtonExpandScreen } from "components/iconButtons/IconButtonExpandScreen";
import { createAutoCompleteModel } from "components/MprcAutoComplete/AutoCompleteDataModel";
import { AutoCompleteHierarchicalModel } from "components/MprcAutoCompleteHierarchical";
import { TopicAutoCompleteHierarchicalModel } from "components/MprcAutoCompleteHierarchical/AutoCompleteHierarchicalModel";
import { Delta, EmitterSource, QuillCommands, QuillUnprivilegedEditor } from "components/Quill";
import { AsyncUploadResult, CreateOrUpdatePostCommand, GetPostPublicationDto, GetPublicationAttachDto, PublicationApprovalStatus, PublicationAttachFileItem, PublicationAttachType, PublicationCreationSettingsResponse, PublicationTagItem, PublicationType, TopicAutoCompleteHierarchicalModelDto } from "generated/CoreApi_v1";
import { useReferredState } from "hooks/useReferredState";
import { Formaters } from "lib/Formaters";
import LibUtils from "lib/LibUtils";
import LinkifyIt from "linkify-it";
import { useSnackbar } from "notistack";
import { useCoreApi } from "providers/CoreApiProvider";
import { useSession } from "providers/SessionProvider";
import * as React from 'react';
import { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import { Link } from "react-router";
import { KnowledgePaths } from "routes/KnowledgeRouter";
import { NIL, v4 as uuidv4 } from 'uuid';
import { publish } from "views/knowledge/feed/FeedEvents";
import { ICreatePublicationProps } from "views/knowledge/publication/creation";
import {
    IInstitutionalBoxValidation,
    IPublicationChannelBoxValidation,
    isPresentationAttach,
    PublicationAdvancedBox,
    PublicationAttachFileHandler,
    PublicationAttachView,
    PublicationChannelBox,
    PublicationEditor,
    PublicationMediaView, PublicationMediaViewData,
    PublicationTopicsBox
} from "views/knowledge/publication/creation/components";
import { PublicationDialogContent } from "views/knowledge/publication/creation/components/PublicationDialogContent";
import { IStickerBoxValidation } from "views/knowledge/publication/creation/components/PublicationStickerBox";

///
export function parseContentTopics(text: string, currentTopics: TopicAutoCompleteHierarchicalModel[]) {
    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(text, "text/html");
    const result: TopicAutoCompleteHierarchicalModel[] = [...currentTopics];

    Array.from(htmlDoc.getElementsByClassName("mention")).forEach((el) => {
        const dataId = el.getAttribute("data-id");
        const dennotationChar = el.getAttribute("data-denotation-char");
        const text = el.getElementsByTagName("A").length == 1 ? el.getElementsByTagName("A")[0].textContent ?? "?" : "?";
        if (dennotationChar == "#") {
            if (currentTopics.find(p => p.key == dataId) == null) {
                result.push(createAutoCompleteModel(dataId, text) as unknown as TopicAutoCompleteHierarchicalModel);
            }
        }
    });

    return result;
}

///
export function forceRichEditor(html: string | null | undefined) {
    let forceRichEditor = false;
    if (html != null) {
        const tags = ["<a ", "<b>", "<b ", "<i", "<s", "<strong", "<em", "<img", "<ol", "<ul", "<li", "<font", "<blockquote", "<pre"];
        for (var i = 0; i < tags.length && !forceRichEditor; i++) forceRichEditor = html.indexOf(tags[i]) > -1;
    }
    return forceRichEditor;
}

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IValidation {
    title?: boolean;
    description?: boolean;
    editJustification?: boolean;
}

interface IPublicationEditJustificationValidation {
}

interface IState {
    record: GetPostPublicationDto;
    validation: IValidation & IInstitutionalBoxValidation & IPublicationChannelBoxValidation & IStickerBoxValidation & IPublicationEditJustificationValidation;
    uploadingStatus: UploadingStatus;
    forceRichEditor: boolean;
}

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const CreatePost = (props: ICreatePublicationProps) => {
    const { onClose } = props;
    const qlEditorId = `ql${new Date().getTime()}`;
    const minHeight = 200;
    const { t } = useTranslation("knowledge");
    const { enqueueSnackbar } = useSnackbar();
    const api = useCoreApi();
    const session = useSession();

    const initialContentRef = useRef<string>("");
    const editorRef = useRef<QuillCommands | null>(null);
    const config = useRef<PublicationCreationSettingsResponse | null>(null);
    const [contentTopics, setContentTopics] = useState<TopicAutoCompleteHierarchicalModel[]>([]);

    const [step, setStep] = useState<number>(1);
    const [lastError, setLastError] = useState<any>();
    const [formCycle, setFormCycle] = useState<RequestLifeCycle>(RequestLifeCycle.None);
    const [fullScreenMode, setFullScreenMode] = useState<boolean>(false);
    const [richEditor, setRichEditor] = useState<boolean>(false);
    const [loadDto, setLoadDto] = useState<GetPostPublicationDto>();
    const [recordChanged, setRecordChanged] = useState<boolean>(false);

    const metadataProcessing = useRef<string[]>([]);

    const steps = [];
    const StepFirstPage = 1;
    const StepSecondPage = 2;
    const StepThrirdPage = 3;

    const [state, setState, refState] = useReferredState<IState>(
        {
            record: {
                publicationId: NIL,
                content: "",
                title: "",
                topics: [],
                attachs: [],
                advancedOptions: {
                    isInstitutional: false,
                    viewPeriodStart: null,
                    viewPeriodEnd: null,
                    viewStickerUntil: null,
                    sticker: null,
                    tags: []
                },
                isDraft: false,
                channel: null!,
                publicationType: PublicationType.Post,
                presentation: null,
                editJustification: null
            },
            validation: {
                title: undefined,
                description: undefined,
                channel: undefined,
                period: true,
                viewStickerUntil: true,
                editJustification: true,
            },

            uploadingStatus: "none",
            forceRichEditor: false,
        });


    ///
    const updateRecord = (data: Partial<GetPostPublicationDto>) => {
        return { ...refState.current.record, ...data };
    };

    ///
    const validateDescription = (text: string, html: string, files: GetPublicationAttachDto[] | null) => {
        return (html != null && html != "<p><br></p>") || (files != null && files.length > 0);
    };

    ///
    let delayAnalyze: ReturnType<typeof setTimeout> | null = null;

    const handleEditorChange = (content: string, delta: Delta, source: EmitterSource, editor: QuillUnprivilegedEditor) => {
        const text = editor.getText().trim();
        const html = editor.getHTML();

        if (delayAnalyze) clearInterval(delayAnalyze);

        setState({
            ...refState.current,
            record: updateRecord({ content: html }),
            validation: { ...refState.current.validation, description: validateDescription(text, html, state.record.attachs) }
        });

        delayAnalyze = setTimeout(() => analyse(content), 500);
    };

    ///
    const handleTitleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
        var v = event.target.value;
        setState({
            ...state,
            record: updateRecord({ title: v }),
            validation: { ...state.validation, title: v.length > 0 }
        });
    };

    ///
    const handlePresentation = (data: PublicationMediaViewData) => {
        setState({
            ...state,
            record: updateRecord({ presentation: data.presentation, attachs: data.attachs })
        });
    };

    ///
    const handleFileUploaded = (e: AsyncUploadResult) => {
        const data: FileThumbnaildGetDto = ConvertUploadToFileThumbnaildGetDto(e);
        const attachType: PublicationAttachType = (PublicationAttachType[e.mainFile.metadata.type as any]) as any;
        const attachs = refState.current.record.attachs.splice(0);

        var at = {
            attachId: uuidv4(),
            file: {
                fileId: data.mainFile.fileId,
                metadata: data.mainFile.metadata,
                mimetype: data.mainFile.mimetype,
                url: data.mainFile.url
            },
            thumbnail: data.thumbnail == null
                ? null
                : {
                    fileId: data.thumbnail.fileId,
                    metadata: data.thumbnail.metadata,
                    mimetype: data.thumbnail.mimetype,
                    url: data.thumbnail.url
                },
            attachType: attachType,
            isEmbed: false,
            linkMetadata: null,
            videoProcessed: false,
            caption: null,
        } as GetPublicationAttachDto;

        attachs.push(at);

        const presentation = addToPresentation(at);

        const newTitle = refState.current.record.title == "" ? Formaters.capitalizedTitle(LibUtils.getFilenameWithoutExtension(data.mainFile.metadata.filename)) ?? refState.current.record.title : refState.current.record.title;

        setState({
            ...refState.current,
            record: updateRecord({ attachs: attachs, presentation: presentation, title: newTitle }),
            validation: { ...refState.current.validation, title: newTitle.length > 0 }
        });
    };

    ///
    const handleUploadingStatus = (status: UploadingStatus) => {
        setState({ ...refState.current, uploadingStatus: status });
    };

    ///
    const analyse = (text: string) => {
        const attachs = refState.current.record.attachs.slice(0) ?? [];
        const linkify = new LinkifyIt();
        const matches = linkify.match(text);

        if (matches == null || matches.length == 0)
            return;

        matches.forEach((m) => {
            const existsRequest = metadataProcessing.current.some(x => x == m.url);
            if (!existsRequest && attachs.find(p => p.linkMetadata != null && p.linkMetadata.url == m.url) == null) {
                metadataProcessing.current.push(m.url);
                api.v1.urlParser.getMetadata({ url: m.url })
                    .then((response) => {
                        if (response.status == 200) {
                            const metadata = response.data;
                            if (metadata.externalId == null || attachs.find(p => p.linkMetadata != null && p.linkMetadata.externalId == metadata.externalId) == null) {
                                const attachType: PublicationAttachType = (PublicationAttachType[metadata.provider as any]) as any;

                                var at = {
                                    attachId: uuidv4(),
                                    file: null,
                                    thumbnail: null,
                                    attachType: attachType,
                                    isEmbed: false,
                                    linkMetadata: metadata,
                                    videoProcessed: false,
                                    caption: null,
                                } as GetPublicationAttachDto;
                                attachs.push(at);

                                const presentation = addToPresentation(at);

                                const newTitle = refState.current.record.title != ""
                                    ? refState.current.record.title
                                    : metadata.title != null && metadata.title != ""
                                        ? LibUtils.decodeHtml(metadata.title)
                                        : metadata.siteName != null && metadata.siteName != ""
                                            ? LibUtils.decodeHtml(metadata.siteName)
                                            : "";

                                setState({
                                    ...refState.current,
                                    record: updateRecord({ attachs: attachs, presentation: presentation, title: newTitle }),
                                    validation: { ...refState.current.validation, title: newTitle.length > 0 }
                                });
                            }
                        }
                    })
                    .catch(() => {
                        enqueueSnackbar(t("Publication.Common.NotIdentifyTypeMessage"), { variant: "error" });
                    })
                    .finally(() => {
                        metadataProcessing.current = metadataProcessing.current.filter(x => x != m.url);
                    });
            }
        });
    };

    ///
    const addToPresentation = (attach: GetPublicationAttachDto) => {
        let presentation = refState.current.record.presentation;

        if (isPresentationAttach(attach.attachType)) {
            if (!presentation) {
                presentation = { orderedItems: [attach.attachId], rotationInterval: 0 };
            }
            else {
                presentation = { ...presentation, orderedItems: [...presentation.orderedItems, attach.attachId] };
            }
        }
        return presentation;
    };

    ///
    const setDefaultValues = () => {
        if (config.current && config.current.defaultChannel.length > 0) {
            const channel = config.current.defaultChannel[0];
            setState({
                ...state,
                record: updateRecord({
                    channel: {
                        channelId: channel.key,
                        name: channel.label,
                        isPrivate: channel.isPrivate,
                        requirePublicationEditJustification: channel.requirePublicationEditJustification,
                        thumbnailUrl: channel.thumbnailUrl!
                    }
                }),
                validation: { ...state.validation, channel: true }
            });
        }
        if (config.current && config.current.topics.length > 0) {
            setState({
                ...state,
                record: updateRecord({ topics: config.current.topics }),
            });
        }
    };

    ///
    const loadSettings = async () => {
        setFormCycle(RequestLifeCycle.Loading);

        api.v1.knowledgePublication.getCreationSettings({ defaultChannelId: props.channelId ?? null, defaultTopicId: props.topicId ?? null, exclusiveListId: null })
            .then((result) => {
                config.current = result.data;
                setDefaultValues();
                setFormCycle(RequestLifeCycle.None);
            })
            .catch((error: any) => {
                setLastError(error);
                setFormCycle(RequestLifeCycle.LoadFailed);
            });
    };

    ///
    const load = async (publicationId: string) => {
        setFormCycle(RequestLifeCycle.Loading);

        Promise.all([
            api.v1.knowledgePublication.getCreationSettings({ defaultChannelId: null, defaultTopicId: null, exclusiveListId: null }),
            api.v1.knowledgePublication.getPostPublication({ publicationId }),
        ])
            .then((results) => {
                config.current = results[0].data;

                const record = results[1].data;
                setState({
                    uploadingStatus: "none",
                    forceRichEditor: forceRichEditor(record.content),
                    record,
                    validation: {
                        channel: true,
                        title: true,
                        description: true,
                        period: true,
                        editJustification: !record.channel.requirePublicationEditJustification
                    }
                });
                setLoadDto(LibUtils.deepCopy(record));
                initialContentRef.current = record.content ?? "";
                setFormCycle(RequestLifeCycle.None);
            })
            .catch((error: any) => {
                setLastError(error);
                setFormCycle(RequestLifeCycle.LoadFailed);
            });
    };

    ///
    const save = (isDraft: boolean) => {

        setFormCycle(RequestLifeCycle.Posting);

        const { record } = state;

        const files: PublicationAttachFileItem[] = record.attachs.map((v) => ({
            attachId: v.attachId,
            fileId: v.file?.fileId ?? null,
            thumbnailId: v.thumbnail?.fileId ?? null,
            cardImageId: v.cardImage?.fileId ?? null,
            linkMetadata: v.linkMetadata,
            caption: v.caption,
            binderPageRefId: null,
        }));

        const dto: CreateOrUpdatePostCommand = {
            publicationId: record.publicationId,
            content: record.content,
            title: record.title,
            advancedOptions: {
                isInstitutional: record.advancedOptions.isInstitutional,
                stickerId: record.advancedOptions.sticker?.stickerId ?? null,
                viewStickerUntil: record.advancedOptions.viewStickerUntil,
                viewPeriodEnd: record.advancedOptions.viewPeriodEnd,
                viewPeriodStart: record.advancedOptions.viewPeriodStart,
                tags: record.advancedOptions.tags.map((tag) => ({ tagId: tag.tagId, tagName: tag.tagName } as PublicationTagItem))
            },
            isDraft: isDraft,
            attachs: files,
            presentation: record.presentation,
            topics: record.topics.map((item) => item.key),
            channelId: record.channel?.channelId,
            threadId: null,
            contentUnformatted: null,
            editJustification: record.editJustification
        };

        api.v1.knowledgePublication.createOrUpdatePostPublication(dto)
            .then((response) => {
                onClose(response.data);
                setFormCycle(RequestLifeCycle.None);

                if (response.data.newPublicationId) {

                    if (!isDraft) {
                        if (response.data.approvalStatus == PublicationApprovalStatus.Approved) {
                            publish("PublicationCreated", response.data.newPublicationId);
                            publish("AuthorNewPublication", session.user.userId);
                            publish("ChannelNewPublication", dto.channelId);
                            dto.topics.forEach(topicId => publish("TopicNewPublication", topicId));

                            enqueueSnackbar(
                                t("Publication.CreatePost.PublishMessage")
                                , {
                                    variant: "mprcAction",
                                    action: <Link to={KnowledgePaths.PublicationViewerResolver(response.data.newPublicationId, PublicationType.Post)}>{t("Publication.Messages.OpenPublication")}</Link>
                                }
                            );
                        }
                        else {
                            enqueueSnackbar(t("Publication.CreatePost.PublishModerationMessage"), { variant: "warning" });
                        }
                    }
                    else {
                        publish("PublicationDraftCreated", response.data.newPublicationId);
                        enqueueSnackbar(t("Publication.CreatePost.PublishDraftMessage"), { variant: "info" });
                    }
                }
                else {
                    if (response.data.success == true) {
                        if (response.data.approvalStatus == null || response.data.approvalStatus == PublicationApprovalStatus.Approved) {
                            publish("PublicationUpdate", record.publicationId);
                            enqueueSnackbar(t("Publication.CreatePost.PublishUpdateMessage"), { variant: "success" });
                        }
                        else {
                            enqueueSnackbar(t("Publication.CreatePost.PublishModerationUpdateMessage"), { variant: "warning" });
                        }
                    }
                    else {
                        enqueueSnackbar(t("shared:Record.FailSuccessMessage"), { variant: "error" });
                    }
                }
            })
            .catch((error) => {
                setLastError(error);
                setFormCycle(RequestLifeCycle.PostFailed);
            });
    };


    ///
    const goStep2 = () => {
        initialContentRef.current = refState.current.record.content ?? "";

        if (refState.current.record.publicationId == NIL) {
            const currentTopics = refState.current.record.topics;
            const topics = parseContentTopics(refState.current.record.content ?? "", currentTopics as TopicAutoCompleteHierarchicalModel[]);

            topics.filter(p => p.selectable).forEach((topic) => {
                if (currentTopics.find(p => p.key == topic.key) == null && currentTopics.length < 5) {
                    currentTopics.push(topic as TopicAutoCompleteHierarchicalModelDto);
                    topic.selectable = false;
                }
            });

            setContentTopics(topics);
            updateRecord({ topics: currentTopics });
        }

        setStep(2);
    };

    ///
    const canGoStep2 = () => {
        const { validation, uploadingStatus, record: { attachs } } = state;
        return (uploadingStatus != "uploading" && validation.title === true && (validation.description === true || attachs.length > 0));
    };

    ///
    const goStep3 = () => {
        setStep(3);
    };

    ///
    const canGoStep3 = () => {
        const { validation } = state;
        return (validation.channel != null);
    };

    ///
    const canSave = (): boolean => {
        const { validation, record } = state;
        return canGoStep2()
            && validation.channel === true
            && validation.period === true
            && (validation.viewStickerUntil == undefined || validation.viewStickerUntil == true)
            && (recordChanged || record.isDraft)
            && (!record.channel.requirePublicationEditJustification || validation.editJustification === true);
    };

    ///
    const getContinueButton = () => {
        return (
            <MprcButton
                variant="contained"
                color="primary"
                disabled={!canGoStep2()}
                onClick={goStep2}
            >
                <span>{t("Publication.Common.Form.ButtonContinueText")}</span>
            </MprcButton>
        );
    };


    ///////////////////////////////////////////////////////////////////////
    /// Passos do Formulário
    ///////////////////////////////////////////////////////////////////////

    ///
    steps[StepFirstPage] = () => {
        const { record, validation, forceRichEditor, } = state;

        return (
            <>
                <PublicationDialogContent>

                    <TextField
                        autoFocus
                        fullWidth
                        name="title"
                        margin="normal"
                        placeholder={t("Publication.CreatePost.TitlePlaceholder")}
                        autoComplete="off"
                        tabIndex={0}
                        value={record.title}
                        error={validation.title === false}
                        slotProps={{
                            input: {
                                inputProps: { maxLength: 255 }
                            }
                        }}
                        onChange={(e) => handleTitleChange(e)}
                    />

                    <PublicationEditor
                        id={qlEditorId}
                        minHeight={minHeight}
                        toolbar={richEditor || forceRichEditor}
                        readOnly={false}
                        initialValue={initialContentRef.current}
                        placeholder={t("Publication.CreatePost.EditorPlaceholder")}
                        onChange={handleEditorChange}
                        ref={editorRef}
                    />

                    <PublicationMediaView
                        data={
                            {
                                presentation: record.presentation,
                                attachs: record.attachs,
                            }
                        }
                        onChange={handlePresentation}
                        onUploading={(uploading) => handleUploadingStatus(uploading ? "uploading" : "none")}
                    />

                    <PublicationAttachView
                        attachs={record.attachs}
                        onChange={
                            (attachs) => setState({
                                ...state,
                                record: updateRecord({ attachs }),
                                validation: { ...state.validation, ...validation }
                            })
                        }
                    />

                    <PublicationAttachFileHandler
                        publicationId={record.publicationId}
                        attachs={record.attachs}
                        allowAttachVideo={config.current?.allowAttachVideo}
                        maxSize={config.current?.maxAttachSize ?? undefined}
                        onUploadComplete={handleFileUploaded}
                        onUploadStatusChange={handleUploadingStatus}
                        additionalLeftButton={
                            [
                                <IconButton key="richEditor" onClick={() => setRichEditor(!richEditor)} title={t("Publication.Common.Editor.FormatTooltip")}>
                                    <MprcText color={richEditor ? "highlight" : "inherit"}>
                                        <FontAwesomeIcon icon={faPaintbrush} fixedWidth />
                                    </MprcText>
                                </IconButton>
                            ]
                        }
                    />
                </PublicationDialogContent>

                <DialogActions>
                    <Grid container justifyContent="space-between" alignItems="center" width="100%">
                        <Grid>
                            <b>{t("Publication.CreatePost.Footer1")}</b>
                            <span>&nbsp;&raquo;&nbsp;</span>
                            <span>{t("Publication.CreatePost.Footer2")}</span>
                        </Grid>

                        <Grid>
                            {
                                getContinueButton()
                            }
                        </Grid>
                    </Grid>
                </DialogActions>
            </>
        );
    };

    ///
    steps[StepSecondPage] = () => {
        const { record, validation } = state;
        return (
            <>
                <DialogContent>

                    <PublicationChannelBox
                        channel={record.channel}
                        suggestions={config.current!.channelSuggestions}
                        onUpdateState={
                            ({ channel, validation }) => setState({
                                ...state,
                                record: updateRecord({ channel: channel! }),
                                validation: {
                                    ...state.validation,
                                    editJustification: channel?.requirePublicationEditJustification == true,
                                    ...validation
                                }
                            })
                        }
                        validation={validation}
                    />

                    <PublicationTopicsBox
                        channelId={record.channel?.channelId}
                        topics={record.topics as AutoCompleteHierarchicalModel[]}
                        suggestions={contentTopics}
                        publication={{ title: record.title, content: record.content }}
                        onUpdateState={
                            (topics) => setState({
                                ...state,
                                record: updateRecord({ topics: topics as TopicAutoCompleteHierarchicalModelDto[] })
                            })
                        }
                    />

                    <PublicationAdvancedBox
                        channelId={record.channel?.channelId}
                        allowInstitutionalPublisher={config.current?.allowInstitutionalPublisher ?? false}
                        canCreateTags={config.current?.canCreateTags ?? false}
                        onUpdateState={({ advancedOptions, validation }) => {
                            setState({
                                ...state,
                                record: updateRecord({ advancedOptions: { ...advancedOptions } }),
                                validation: { ...state.validation, ...validation }
                            });
                        }}
                        advancedOptions={{ ...record.advancedOptions }}
                        validation={validation}
                    />
                </DialogContent>

                <DialogActions>
                    <Grid container justifyContent="space-between" alignItems="center" spacing={2} width="100%">
                        <Grid>
                            {
                                (record.publicationId == NIL || record.isDraft) &&
                                <MprcButton
                                    variant="contained"
                                    color="warning"
                                    onClick={() => save(true)}
                                    disabled={!canSave()}
                                >
                                    <span>{t("Publication.Common.Form.ButtonDraftText")}</span>
                                </MprcButton>
                            }
                        </Grid>

                        <Grid>
                            <MprcButton
                                variant="contained"
                                onClick={() => setStep(1)}
                                sx={{ mr: 1 }}
                            >
                                <span>{t("Publication.Common.Form.ButtonBackText")}</span>
                            </MprcButton>

                            {
                                record.channel?.requirePublicationEditJustification == true && recordChanged
                                    ? <MprcButton
                                        variant="contained"
                                        color="primary"
                                        disabled={!canGoStep3()}
                                        onClick={goStep3}
                                    >
                                        <span>{t("Publication.Common.Form.ButtonContinueText")}</span>
                                    </MprcButton>
                                    : (recordChanged || record.isDraft) && <MprcButton
                                        variant="contained"
                                        color="success"
                                        onClick={() => save(false)}
                                        disabled={!canSave()}
                                    >
                                        <span>{t("Publication.Common.Form.ButtonFinishText")}</span>
                                    </MprcButton>
                            }
                        </Grid>
                    </Grid>
                </DialogActions>
            </>
        );
    };

    steps[StepThrirdPage] = () => {
        const { record, validation } = state;
        return (
            <>
                <DialogContent>
                    <MprcFormSubHeader
                        title={t("Publication.CreatePost.EditJustificationTitle") + " *"}
                        subtitle={t("Publication.CreatePost.EditJustificationSubtitle")}
                        margin="dense"
                    />
                    <TextField
                        autoFocus
                        fullWidth
                        multiline
                        name="editJustification"
                        margin="dense"
                        variant="outlined"
                        rows={5}
                        placeholder={t("Publication.CreatePost.EditJustificationHint")}
                        required
                        slotProps={{
                            input: {
                                inputProps: { maxLength: 2048 }
                            }
                        }}
                        value={record.editJustification ?? ""}
                        error={validation.editJustification == false}
                        onChange={(e) =>
                            setState({
                                ...refState.current,
                                record: updateRecord({ editJustification: e.target.value }),
                                validation: { ...refState.current.validation, editJustification: e.target.value.length > 0 }
                            })
                        }
                    />
                </DialogContent>

                <DialogActions>
                    <Grid container justifyContent="space-between" alignItems="end">
                        <Grid>
                            <MprcButton
                                variant="contained"
                                onClick={() => setStep(2)}
                                sx={{ mr: 1 }}
                            >
                                <span>{t("Publication.Common.Form.ButtonBackText")}</span>
                            </MprcButton>

                            <MprcButton
                                variant="contained"
                                color="success"
                                onClick={() => save(false)}
                                disabled={!canSave()}
                            >
                                <span>{t("Publication.Common.Form.ButtonFinishText")}</span>
                            </MprcButton>
                        </Grid>
                    </Grid>
                </DialogActions>
            </>
        );
    };

    ///////////////////////////////////////////////////////////////////////
    /// Effect's
    ///////////////////////////////////////////////////////////////////////

    useEffect(() => {
        if (richEditor) editorRef.current?.focus();
    }, [richEditor]);

    useEffect(() => {
        const isRecordChanged = !LibUtils.deepCompare(state.record, loadDto);
        setRecordChanged(isRecordChanged);
    }, [state]);

    // Ao carregar registro para edição
    useEffect(() => {
        if (props.publicationId)
            load(props.publicationId);
        else
            loadSettings();
    }, []);

    ///////////////////////////////////////////////////////////////////////
    /// Render
    ///////////////////////////////////////////////////////////////////////
    return (
        <Dialog
            open={true}
            maxWidth={"md"}
            fullWidth
            fullScreen={fullScreenMode}
            sx={fullScreenMode ? { "& .MuiPaper-root": { maxHeight: "90%", maxWidth: "90%" } } : undefined}
        >
            <DialogTitle>
                <Grid container justifyContent="space-between">
                    <Grid>
                        <Typography variant="h4">
                            {t(state.record.publicationId == NIL ? "Publication.CreatePost.TitleNew" : "Publication.CreatePost.TitleEdit")}
                        </Typography>
                    </Grid>
                    <Grid>
                        <IconButtonExpandScreen
                            expanded={fullScreenMode}
                            size="small"
                            onClick={() => setFullScreenMode(!fullScreenMode)}
                        />
                        <IconButtonClose
                            color="inherit"
                            size="small"
                            onClick={() => onClose(null)}
                        />
                    </Grid>
                </Grid>
            </DialogTitle>

            <MprcRequestIndicator type="request" visible={formCycle == RequestLifeCycle.Loading} />

            <MprcRequestIndicator type="post" visible={formCycle == RequestLifeCycle.Posting} />

            {
                lastError && formCycle == RequestLifeCycle.LoadFailed
                    ? <MprcRequestErrorReport error={lastError} />
                    : (
                        <>
                            <MprcRequestErrorDialog error={lastError} onClose={() => setLastError(null)} />
                            {steps[step]()}
                        </>
                    )
            }

        </Dialog>
    );
};
